module.exports = __webpack_public_path__ + "static/media/10.5119d5bb.JPG";